<template>
  <div id="app">

    <img v-if="ishome" class="bg" src="@/assets/bg.png" alt="">
    <Header></Header>
    <div :class="[{ 'svip': issvip }, 'main']">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './components/header/header.vue'
import Footer from './components/footer/footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      ishome: false,
      issvip: false
    }
  },
  watch: {
    $route() {
      this.ishome = this.$route.path === '/'
      this.issvip = this.$route.path.indexOf('membership') > -1
    }
  },
  mounted() {
    this.ishome = this.$route.path === '/'
  }
}

</script>
<style>
* {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

ul {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;

  text-decoration: none;
}

.home {
  max-width: 1327px;
  margin: 0 auto;
}

/* 重置 Vue Router 链接的样式 */
router-link {
  color: inherit;
  text-decoration: none;
}

#app {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bg {
  position: absolute;
  top: -125px;
  left: 121px;
  width: 1233px;
  height: 1233px;
  z-index: -1;
}

.main {
  /* padding-top: 82px; */
}

.svip {
  background: linear-gradient(90deg, #E7E7FF 0%, #ECDFFB 50%, #FEE7F1 100%);
  color: #fff;
}

/* 移动端样式 (小于768px) */
@media screen and (max-width: 767px) {
  .home {
    max-width: 89%;
    margin: 0 auto;
  }
}
</style>
